(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc2-footer"]) return;
  try {
    
(function(){
  var btn=document.querySelector('.mc2-totop');
  if(!btn||btn.__mc2totop){return;} btn.__mc2totop=true;
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function onScroll(){ btn.classList.toggle('is-visible',(window.pageYOffset||document.documentElement.scrollTop)>400); }
  window.addEventListener('scroll',onScroll,{passive:true});
  onScroll();
  btn.addEventListener('click',function(){ window.scrollTo({top:0,behavior:reduce?'auto':'smooth'}); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc2-home"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(root.__mc2){return;} root.__mc2=true;

    // MODERN: hub hover preview
    var hub=root.querySelector('[data-mc2-hub]');
    if(hub){
      var slot=root.querySelector('[data-mc2-preview-slot]');
      var img=root.querySelector('[data-mc2-preview-img]');
      var cap=root.querySelector('[data-mc2-preview-cap]');
      hub.querySelectorAll('.mc2-metal').forEach(function(a){
        function show(){ if(img){img.src=a.getAttribute('data-img');img.alt=a.getAttribute('data-cap')||'';} if(cap){cap.textContent=a.getAttribute('data-cap')||'';} }
        a.addEventListener('mouseenter',show);
        a.addEventListener('focus',show);
      });
      if(cap){var f=hub.querySelector('.mc2-metal');if(f)cap.textContent=f.getAttribute('data-cap')||'';}
    }

    // MODERN: testimonial carousel
    var car=root.querySelector('[data-mc2-carousel]');
    if(car){
      var slides=car.querySelectorAll('.mc2-tslide');
      var dots=car.querySelectorAll('.mc2-tdot');
      var posEl=car.querySelector('.mc2-tpos');
      var i=0, n=slides.length;
      function go(x){
        i=(x+n)%n;
        slides.forEach(function(s,idx){s.classList.toggle('is-active',idx===i);});
        dots.forEach(function(d,idx){d.classList.toggle('is-current',idx===i);d.setAttribute('aria-current',idx===i?'true':'false');});
        if(posEl)posEl.textContent=(i+1)+' / '+n;
      }
      dots.forEach(function(d,idx){d.addEventListener('click',function(){go(idx);});});
      var prev=car.querySelector('[data-mc2-prev]'), next=car.querySelector('[data-mc2-next]');
      if(prev)prev.addEventListener('click',function(){go(i-1);});
      if(next)next.addEventListener('click',function(){go(i+1);});
      go(0);
    }

    // CLASSIC: hover image swap
    var links=root.querySelectorAll('.mc2-material-links a');
    var stImg=root.querySelector('.mc2-screw-type');
    if(links.length&&stImg){
      links.forEach(function(a){
        a.addEventListener('click',function(e){e.preventDefault();});
        a.addEventListener('mouseover',function(){stImg.src=a.getAttribute('data-img');stImg.alt=a.textContent;});
      });
    }
  }
  document.querySelectorAll('.mc2-home').forEach(init);
  document.addEventListener('shopify:section:load',function(e){var el=e.target.querySelector('.mc2-home');if(el){el.__mc2=false;init(el);}});
})();

  } catch(e) { console.error(e); }
})();
})();
